import React from 'react'

import { colors } from '@atlaskit/theme'

import { ZeraIcon } from '@zera-admin/logo'
import Spinner from '@zera-admin/spinner'

import { SplashScreenProps } from './types'
import {
  SplashScreenFlex,
  SplashScreenFlexRow,
  SplashScreenWrapper,
  SplashScreenPrograssBar,
} from './SplashScreen.styled'

const SplashScreen: React.FunctionComponent<SplashScreenProps> = ({
  error,
}) => {
  return (
    <React.Fragment>
      <SplashScreenFlex>
        <SplashScreenFlexRow>
          <SplashScreenWrapper>
            <ZeraIcon size="large" />
            {error ? (
              <React.Fragment>
                <p>{error.message}</p>
                <p>
                  {error.code}: {error.name}
                </p>
              </React.Fragment>
            ) : (
              <SplashScreenPrograssBar>
                <Spinner />
              </SplashScreenPrograssBar>
            )}
          </SplashScreenWrapper>
        </SplashScreenFlexRow>
      </SplashScreenFlex>
    </React.Fragment>
  )
}

export default SplashScreen
